import Vue from 'vue'

Vue.filter('numberPointFilter', function (value) {
  if (typeof value !== "number") {
    return value;
  }

  if (value >= 1000) {
    const formatNumber = (value / 1000).toLocaleString('pt-PT', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
      return formatNumber.replace(',', '.')
  }

  return +value;
});
